import React from "react";
const Product = ({ props }) => {
  return (
    <div style={{flexWrap:'nowrap',overflowY:'auto'}} className="row products_row">
      {props.homePage.productsDetails.map((product, i) => (
        <div key={i} className="col-12 col-sm-6 col-xl-4 col-lg-4 col-md-6">
          <div className="product" style={{margin:"20px"}}>
            <div  className="product_image">
              <img id='productImage' style={{border:'2px solid lightgray'}}  src={product.img} alt="" />
            </div>
            <div id='productContent' className="product_content col-12 col-xl-4 col-md-6">
              <div className="product_info d-flex flex-row align-items-start justify-content-start">
                <div>
                  <div>
                    <div className="product_name">
                      <a>
                        {product.describtion}
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div></div>
                </div>
                <div className="ml-auto text-right">
                  <div className="rating_r rating_r_4 home_item_rating">
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                    <i></i>
                  </div>
                  <div className="product_price text-right">
                    {product.price}
                    <span>EGP</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Product;
